var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M1803 1099q0 51-37 90l-75 75q-38 38-91 38-54 0-90-38l-294-293v704q0 52-37.5 84.5t-90.5 32.5h-128q-53 0-90.5-32.5t-37.5-84.5v-704l-294 293q-36 38-90 38t-90-38l-75-75q-38-38-38-90 0-53 38-91l651-651q35-37 90-37 54 0 91 37l651 651q37 39 37 91z"}));
}

ArrowUp.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 2048 2048"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
